var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"filter"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"filter"},[_vm._t("left")],2),(_vm.hasRightSlot)?_c('div',{staticClass:"filter"},[_vm._t("right")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }